import Result from './Result.vue';

export default Result;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/result/index.ts